export default __webpack_public_path__ + "static/media/153.b97413e9.png";